// Source/Input-Select/Component.ts
class Input_Select extends HTMLElement {
  controller;
  connectedCallback() {
    this.controller = new AbortController;
    const input = this.querySelector(`input`);
    const custom = this.dataset.customOption;
    const update = () => {
      if (input.value === custom)
        input.value = "";
      else
        input.blur();
    };
    const { signal } = this.controller;
    input.addEventListener("change", update, { signal });
    input.addEventListener("blur", update, { signal });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
}

// Source/Input-Select/mod.ts
customElements.define("input-select", Input_Select);
